import React, { useState } from "react";
import {
  globalStyle,
  handleVisible,
  handleDangerVisible,
} from "../../global/Utils";
import { addHsCode as addingHsCode } from "../../Actions/HSCodeAction";
import { useDispatch, useSelector } from "react-redux";

import { upperCaseInput } from "../../global/textCase";
const AddHsCode = () => {
  const dispatch = useDispatch();
  const isAddingHsCodeList = useSelector(
    (state) => state.HsCodeListReducer?.isAddingHsCodeList,
  );
  const [formData, setFormData] = useState({
    pctCode: "",
    description: "",
  });

  const [errors, setErrors] = useState({
    pctCode: "",
  });

  const handleChange = (e) => {
    const { name, value } = upperCaseInput(e.target);
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Clear error while typing
    if (value.trim() !== "") {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let hasError = false;
    const newErrors = {};

    if (!formData.pctCode.trim()) {
      newErrors.pctCode = "Pct Code is required";
      hasError = true;
    }

    setErrors(newErrors);

    if (!hasError) {
      dispatch(
        addingHsCode(formData, setFormData, handleVisible, handleDangerVisible),
      );
    }
  };
  return (
    <div className="w-full min-h-[74vh] flex items-start justify-center py-6">
      <form
        onSubmit={handleSubmit}
        className="w-full flex flex-col items-center"
      >
        {/* Heading */}
        <h2
          className="text-xl font-bold mb-6 text-center"
          style={{
            fontFamily: globalStyle.fontFamilyHeading,
            fontSize: globalStyle.headingFontSizeSmall,
            color: globalStyle.curveDarkColor,
          }}
        >
          Add Information
        </h2>

        {/* Inputs */}
        <div className="flex flex-col md:flex-row md:space-x-4 w-full">
          {/* Pct Code */}
          <div className="mb-4 md:mb-0 md:flex-1">
            <label
              htmlFor="pctCode"
              className="block mb-1 font-medium"
              style={{ fontFamily: globalStyle.fontFamilyParagraph }}
            >
              Pct Code <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="pctCode"
              name="pctCode"
              value={formData.pctCode}
              onChange={handleChange}
              className={`w-full px-4 py-2 border rounded-md focus:outline-none ${
                errors.pctCode
                  ? "border-red-500"
                  : "border-gray-300 focus:border-blue-500"
              }`}
            />
            {errors.pctCode && (
              <p className="text-red-500 text-sm mt-1">{errors.pctCode}</p>
            )}
          </div>

          {/* Description */}
          <div className="mb-6 md:mb-0 md:flex-1">
            <label
              htmlFor="description"
              className="block mb-1 font-medium"
              style={{ fontFamily: globalStyle.fontFamilyParagraph }}
            >
              Description
            </label>
            <input
              type="text"
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              className={`w-full px-4 py-2 border rounded-md focus:outline-none border-gray-300 focus:border-blue-500`}
            />
          </div>
        </div>

        {/* Submit button */}
        <div className="w-full flex justify-center">
          <button
            type="submit"
            disabled={isAddingHsCodeList}
            className="w-full md:w-1/3 mt-4 py-2 rounded-md text-white font-bold disabled:bg-gray-400 disabled:cursor-not-allowed disabled:opacity-50"
            style={{
              fontFamily: globalStyle.fontFamilyButton,
              background: globalStyle.buttonColor,
            }}
          >
            {isAddingHsCodeList ? "Please Wait...." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddHsCode;
